import React, { useEffect, lazy, createElement } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { ClientsSection } from '../components/ClientsSection';
import { FAQSection } from '../components/FAQSection';
import { JobVacancies } from '../components/JobVacancies';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';
export function HomePage() {
  const {
    t
  } = useLanguage();
  // SEO: Set document title and meta description
  useEffect(() => {
    document.title = t('seo.title');
    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', t('seo.description'));
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin + window.location.pathname;
    // Open Graph tags
    const ogTags: Record<string, string> = {
      'og:title': t('seo.title'),
      'og:description': t('seo.description'),
      'og:type': 'website',
      'og:url': window.location.origin + window.location.pathname,
      'og:image': 'https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg',
      'og:site_name': 'ELVORA Consulting'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    // FAQPage structured data (JSON-LD)
    const faqItems = t('faq.items');
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item: any) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a
        }
      }))
    };
    let scriptTag = document.getElementById('faq-structured-data');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = 'faq-structured-data';
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(faqSchema);
    return () => {
      const existingScript = document.getElementById('faq-structured-data');
      if (existingScript) existingScript.remove();
    };
  }, [t]);
  return <div className="min-h-screen bg-white" data-id="element-509">
      <Header data-id="element-510" />
      <main data-id="element-511">
        <HeroSection data-id="element-512" />
        <div className="cv-lazy-section" data-id="element-513">
          <ServicesSection data-id="element-514" />
        </div>
        <div className="cv-lazy-section" data-id="element-515">
          <ClientsSection data-id="element-516" />
        </div>
        <div className="cv-lazy-section" data-id="element-517">
          <FAQSection data-id="element-518" />
        </div>
        <div className="cv-lazy-section" data-id="element-519">
          <JobVacancies data-id="element-520" />
        </div>
        <div className="cv-lazy-section-sm" data-id="element-521">
          <ContactSection data-id="element-522" />
        </div>
      </main>
      <Footer data-id="element-523" />
    </div>;
}